import React, { useMemo } from "react";
import { motion } from "framer-motion";

const NEWS_DATA = [
  {
    id: 1,
    date: "14/08/2015",
    //category: "EVENTS",
    title: "Sholay: The Star Wars of Bollywood?",
    image: "https://images.unsplash.com/photo-1515634928627-2a4e0dae3ddf?q=80&w=1000&auto=format&fit=crop",
    link: "https://www.bbc.com/culture/article/20150813-sholay-the-star-wars-of-bollywood"
  },
  {
    id: 2,
    date: "22/06/2025",
    //category: "THEATRICAL RELEASE",
    title: "Indian Classic ‘Sholay’ Gets World Premiere of Restored Cut at Bologna Festival (EXCLUSIVE)",
    image: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?q=80&w=1000&auto=format&fit=crop",
    link: "https://variety.com/2025/film/news/sholay-restored-cut-world-premiere-bologna-festival-1236437733/"
  },
  {
    id: 3,
    date: "25/06/2025",
    //category: "PRODUCTION",
    title: "Sholay: Bollywood epic roars back to big screen after 50 years with new ending",
    image: "https://images.unsplash.com/photo-1536440136628-849c177e76a1?q=80&w=1000&auto=format&fit=crop",
    link: "https://www.bbc.com/news/articles/cvg8m9z5vv8o"
  },
  {
    id: 4,
    date: "12/12/2025",
    //category: "LEGACY",
    title: "Sholay – The Final Cut Movie Review: Like Vintage Wine, This Classic Only Gets Better With Time!",
    image: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?q=80&w=1000&auto=format&fit=crop",
    link: "https://www.koimoi.com/bollywood-movies/movie-reviews/sholay-the-final-cut-movie-review-like-vintage-wine-this-classic-only-gets-better-with-time/"
  },
  {
    id: 5,
    date: "23/06/2026",
    //category: "CORPORATE",
    title: "‘Sholay’ to Make ‘Films in Concert’ World Premiere at London’s Royal Albert Hall",
    image: "https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?q=80&w=1000&auto=format&fit=crop",
    link: "https://variety.com/2026/film/news/sholay-films-in-concert-world-premiere-royal-albert-hall-1236788085/"
  },
  {
    id: 6,
    date: "15/08/2026",
    //category: "CORPORATE",
    title: "Sholay wins Italy: 2,000 Italians watch restored classic till 3 am, says Amitabh Bachchan",
    image: "https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?q=80&w=1000&auto=format&fit=crop",
    link: "https://economictimes.indiatimes.com/news/new-updates/sholay-wins-italy-2000-italians-watch-restored-classic-till-3-am-says-amitabh-bachchan/articleshow/133257419.cms?from=mdr"
  }
];

const MONTHS = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

// "23/06/2026" -> { time, day: 23, suffix: "rd", month: "JUN", year: 2026 }
function parseDate(str) {
  const [d, m, y] = str.split("/").map(Number);
  const mod100 = d % 100;
  const mod10 = d % 10;
  const suffix =
    mod100 >= 11 && mod100 <= 13 ? "th" : mod10 === 1 ? "st" : mod10 === 2 ? "nd" : mod10 === 3 ? "rd" : "th";
  return { time: new Date(y, m - 1, d).getTime(), day: d, suffix, month: MONTHS[m - 1], year: y };
}

const containerVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.08 } }
};

const itemVariants = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
};

export default function News() {
  // Newest first, like the reference
  const items = useMemo(
    () =>
      NEWS_DATA.map((item) => ({ ...item, parsed: parseDate(item.date) })).sort(
        (a, b) => b.parsed.time - a.parsed.time
      ),
    []
  );

  return (
    <motion.div className="news-page" initial="hidden" animate="visible" variants={containerVariants}>
      <header className="news-header">
        <h1 className="page-title">NEWS</h1>
      </header>

      <ul className="news-list">
        {items.map((item) => (
          <motion.li key={item.id} variants={itemVariants}>
            <a
              className="news-row"
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${item.title} (opens in a new tab)`}
            >
              <div className="news-row__date">
                <span className="news-row__day">
                  {item.parsed.day}
                  <sup>{item.parsed.suffix}</sup>
                </span>
                <span className="news-row__monthyear">
                  {item.parsed.month} {item.parsed.year}
                </span>
              </div>

              <div className="news-row__text">
                <h3 className="news-row__title">{item.title}</h3>
                <span className="news-row__category">{item.category}</span>
              </div>

              <div
                className="news-row__image"
                style={{ backgroundImage: `url(${item.image})` }}
                aria-hidden="true"
              />

              <span className="news-row__arrow" aria-hidden="true">
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 5l7 7-7 7" />
                </svg>
              </span>
            </a>
          </motion.li>
        ))}
      </ul>

      <style>{`
        @font-face {
          font-family: 'Sippy';
          src: url('../font/GothamBook.woff2') format('woff2');
          font-weight: 400;
          font-style: normal;
          font-display: swap;
        }

        @font-face {
          font-family: 'SippyBold';
          src: url('../font/Gotham-Bold.woff2') format('woff2');
          font-weight: 800;
          font-style: normal;
          font-display: swap;
        }

        .news-page {
          background-color: #050505;
          color: #fff;
          min-height: auto;
          /* Clear the fixed navbar. Raise --nav-offset if your navbar is taller. */
          --nav-offset: 170px;
          padding: var(--nav-offset) 5% 60px;
          font-family: 'Sippy', sans-serif;
        }

        .news-header {
          max-width: 1400px;
          margin: 0 auto 48px;
        }

        .page-title {
          font-size: clamp(2.2rem, 4vw, 3.2rem);
          font-weight: 900;
          color: #fff;
          font-family: 'SippyBold', sans-serif;
          text-align: left;
          text-transform: uppercase;
          letter-spacing: -1px;
          margin: 0;
          line-height: 1;
        }

        /* ---------- Linear list ---------- */
        .news-list {
          list-style: none;
          max-width: 1400px;
          margin: 0 auto;
          padding: 0;
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .news-row {
          position: relative;
          display: flex;
          align-items: center;
          min-height: 90px;
          overflow: hidden;
          background: #040f26;
          color: #fff;
          text-decoration: none;
          isolation: isolate;
        }

        .news-row:focus-visible {
          outline: 2px solid #26b8eb;
          outline-offset: 3px;
        }

        /* Date block + vertical divider */
        .news-row__date {
          flex: 0 0 128px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          align-self: stretch;
          margin: 8px 0;
          padding: 0 12px;
          border-right: 1px solid rgba(255, 255, 255, 0.28);
          color: #4b5c7a;
          line-height: 1;
        }

        .news-row__day {
          font-family: 'SippyBold', sans-serif;
          font-size: 2.1rem;
          letter-spacing: -0.5px;
        }

        .news-row__day sup {
          font-size: 0.95rem;
          margin-left: 2px;
          vertical-align: top;
          position: relative;
          top: 0.15em;
        }

        .news-row__monthyear {
          margin-top: 6px;
          font-size: 0.85rem;
          letter-spacing: 0.5px;
        }

        /* Title + category */
        .news-row__text {
          flex: 1 1 auto;
          min-width: 0;
          padding: 14px 80px 14px 24px;
          z-index: 2;
        }

        .news-row__title {
          margin: 0;
          font-family: 'SippyBold', sans-serif;
          font-size: 1.3rem;
          line-height: 1.25;
          font-weight: 700;
        }

        .news-row__category {
          display: block;
          margin-top: 4px;
          color: #4b5c7a;
          font-size: 0.95rem;
        }

        /* Faded image on the right edge */
        .news-row__image {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          width: 38%;
          background-size: cover;
          background-position: center;
          opacity: 0.35;
          z-index: 0;
          transition: opacity 0.3s ease;
          -webkit-mask-image: linear-gradient(to right, transparent, #000 85%);
                  mask-image: linear-gradient(to right, transparent, #000 85%);
        }

        /* Round arrow button */
        .news-row__arrow {
          position: absolute;
          top: 50%;
          right: 20px;
          width: 36px;
          height: 36px;
          transform: translateY(-50%);
          display: grid;
          place-items: center;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.14);
          color: #9aa7bd;
          z-index: 3;
          transition: background 0.3s ease, color 0.3s ease;
        }

        .news-row:hover .news-row__image,
        .news-row:focus-visible .news-row__image {
          opacity: 0.6;
        }

        .news-row:hover .news-row__arrow,
        .news-row:focus-visible .news-row__arrow {
          background: #26b8eb;
          color: #fff;
        }

        .news-row:hover .news-row__day,
        .news-row:focus-visible .news-row__day {
          color: #26b8eb;
        }

        @media (max-width: 700px) {
          .news-row__date { flex-basis: 84px; padding: 0 8px; }
          .news-row__day { font-size: 1.6rem; }
          .news-row__monthyear { font-size: 0.7rem; }
          .news-row__text { padding: 12px 56px 12px 14px; }
          .news-row__title { font-size: 1rem; }
          .news-row__category { font-size: 0.8rem; }
          .news-row__image { width: 55%; }
          .news-row__arrow { right: 12px; width: 30px; height: 30px; }
        }

        @media (prefers-reduced-motion: reduce) {
          .news-row__image,
          .news-row__arrow { transition: none; }
        }
      `}</style>
    </motion.div>
  );
}